export const PROGRAMMING_LANGUAGES = [
  "A# .NET",
  "A# (Axiom)",
  "A-0 System",
  "A+",
  "A++",
  "ABAP",
  "ABC",
  "ABC ALGOL",
  "ABLE",
  "ABSET",
  "ABSYS",
  "ACC",
  "Accent",
  "Ace DASL",
  "ACL2",
  "ACT-III",
  "Action!",
  "ActionScript",
  "Ada",
  "Adenine",
  "Agda",
  "Agilent VEE",
  "Agora",
  "AIMMS",
  "Alef",
  "ALF",
  "ALGOL 58",
  "ALGOL 60",
  "ALGOL 68",
  "ALGOL W",
  "Alice",
  "Alma-0",
  "AmbientTalk",
  "Amiga E",
  "AMOS",
  "AMPL",
  "APL",
  "App Inventor for Android's visual block language",
  "AppleScript",
  "Arc",
  "ARexx",
  "Argus",
  "AspectJ",
  "Assembly language",
  "ATS",
  "Ateji PX",
  "AutoHotkey",
  "Autocoder",
  "AutoIt",
  "AutoLISP / Visual LISP",
  "Averest",
  "AWK",
  "Axum",
  "B",
  "Babbage",
  "Bash",
  "BASIC",
  "bc",
  "BCPL",
  "BeanShell",
  "Batch (Windows/Dos)",
  "Bertrand",
  "BETA",
  "Bigwig",
  "Bistro",
  "BitC",
  "BLISS",
  "Blue",
  "Bon",
  "Boo",
  "Boomerang",
  "Bourne shell",
  "bash",
  "ksh",
  "BREW",
  "BPEL",
  "C",
  "C--",
  "C++",
  "C#",
  "C/AL",
  "Caché ObjectScript",
  "C Shell",
  "Caml",
  "Candle",
  "Cayenne",
  "CDuce",
  "Cecil",
  "Cel",
  "Cesil",
  "Ceylon",
  "CFEngine",
  "CFML",
  "Cg",
  "Ch",
  "Chapel",
  "CHAIN",
  "Charity",
  "Charm",
  "Chef",
  "CHILL",
  "CHIP-8",
  "chomski",
  "ChucK",
  "CICS",
  "Cilk",
  "CL",
  "Claire",
  "Clarion",
  "Clean",
  "Clipper",
  "CLIST",
  "Clojure",
  "CLU",
  "CMS-2",
  "COBOL",
  "Cobra",
  "CODE",
  "CoffeeScript",
  "Cola",
  "ColdC",
  "ColdFusion",
  "COMAL",
  "Combined Programming Language",
  "COMIT",
  "Common Intermediate Language",
  "Common Lisp",
  "COMPASS",
  "Component Pascal",
  "Constraint Handling Rules",
  "Converge",
  "Cool",
  "Coq",
  "Coral 66",
  "Corn",
  "CorVision",
  "COWSEL",
  "CPL",
  "csh",
  "CSP",
  "Csound",
  "CUDA",
  "Curl",
  "Curry",
  "Cyclone",
  "Cython",
  "D",
  "DASL",
  "DASL",
  "Dart",
  "DataFlex",
  "Datalog",
  "DATATRIEVE",
  "dBase",
  "dc",
  "DCL",
  "Deesel",
  "Delphi",
  "DinkC",
  "DIBOL",
  "Dog",
  "Draco",
  "DRAKON",
  "Dylan",
  "DYNAMO",
  "E",
  "E#",
  "Ease",
  "Easy PL/I",
  "Easy Programming Language",
  "EASYTRIEVE PLUS",
  "ECMAScript",
  "Edinburgh IMP",
  "EGL",
  "Eiffel",
  "ELAN",
  "Elixir",
  "Elm",
  "Emacs Lisp",
  "Emerald",
  "Epigram",
  "EPL",
  "Erlang",
  "es",
  "Escapade",
  "Escher",
  "ESPOL",
  "Esterel",
  "Etoys",
  "Euclid",
  "Euler",
  "Euphoria",
  "EusLisp Robot Programming Language",
  "CMS EXEC",
  "EXEC 2",
  "Executable UML",
  "F",
  "F#",
  "Factor",
  "Falcon",
  "Fancy",
  "Fantom",
  "FAUST",
  "Felix",
  "Ferite",
  "FFP",
  "Fjölnir",
  "FL",
  "Flavors",
  "Flex",
  "FLOW-MATIC",
  "FOCAL",
  "FOCUS",
  "FOIL",
  "FORMAC",
  "@Formula",
  "Forth",
  "Fortran",
  "Fortress",
  "FoxBase",
  "FoxPro",
  "FP",
  "FPr",
  "Franz Lisp",
  "Frege",
  "F-Script",
  "FSProg",
  "G",
  "Google Apps Script",
  "Game Maker Language",
  "GameMonkey Script",
  "GAMS",
  "GAP",
  "G-code",
  "Genie",
  "GDL",
  "Gibiane",
  "GJ",
  "GEORGE",
  "GLSL",
  "GNU E",
  "GM",
  "Go",
  "Go!",
  "GOAL",
  "Gödel",
  "Godiva",
  "GOM (Good Old Mad)",
  "Goo",
  "Gosu",
  "GOTRAN",
  "GPSS",
  "GraphTalk",
  "GRASS",
  "Groovy",
  "Hack (programming language)",
  "HAL/S",
  "Hamilton C shell",
  "Harbour",
  "Hartmann pipelines",
  "Haskell",
  "Haxe",
  "High Level Assembly",
  "HLSL",
  "Hop",
  "Hope",
  "Hugo",
  "Hume",
  "HyperTalk",
  "IBM Basic assembly language",
  "IBM HAScript",
  "IBM Informix-4GL",
  "IBM RPG",
  "ICI",
  "Icon",
  "Id",
  "IDL",
  "Idris",
  "IMP",
  "Inform",
  "Io",
  "Ioke",
  "IPL",
  "IPTSCRAE",
  "ISLISP",
  "ISPF",
  "ISWIM",
  "J",
  "J#",
  "J++",
  "JADE",
  "Jako",
  "JAL",
  "Janus",
  "JASS",
  "Java",
  "JavaScript",
  "JCL",
  "JEAN",
  "Join Java",
  "JOSS",
  "Joule",
  "JOVIAL",
  "Joy",
  "JScript",
  "JScript .NET",
  "JavaFX Script",
  "Julia",
  "Jython",
  "K",
  "Kaleidoscope",
  "Karel",
  "Karel++",
  "KEE",
  "Kixtart",
  "KIF",
  "Kojo",
  "Kotlin",
  "KRC",
  "KRL",
  "KUKA",
  "KRYPTON",
  "ksh",
  "L",
  "L# .NET",
  "LabVIEW",
  "Ladder",
  "Lagoona",
  "LANSA",
  "Lasso",
  "LaTeX",
  "Lava",
  "LC-3",
  "Leda",
  "Legoscript",
  "LIL",
  "LilyPond",
  "Limbo",
  "Limnor",
  "LINC",
  "Lingo",
  "Linoleum",
  "LIS",
  "LISA",
  "Lisaac",
  "Lisp",
  "Lite-C",
  "Lithe",
  "Little b",
  "Logo",
  "Logtalk",
  "LPC",
  "LSE",
  "LSL",
  "LiveCode",
  "LiveScript",
  "Lua",
  "Lucid",
  "Lustre",
  "LYaPAS",
  "Lynx",
  "M2001",
  "M4",
  "Machine code",
  "MAD",
  "MAD/I",
  "Magik",
  "Magma",
  "make",
  "Maple",
  "MAPPER",
  "MARK-IV",
  "Mary",
  "MASM Microsoft Assembly x86",
  "Mathematica",
  "MATLAB",
  "Maxima",
  "Macsyma",
  "Max",
  "MaxScript",
  "Maya (MEL)",
  "MDL",
  "Mercury",
  "Mesa",
  "Metacard",
  "Metafont",
  "MetaL",
  "Microcode",
  "MicroScript",
  "MIIS",
  "MillScript",
  "MIMIC",
  "Mirah",
  "Miranda",
  "MIVA Script",
  "ML",
  "Moby",
  "Model 204",
  "Modelica",
  "Modula",
  "Modula-2",
  "Modula-3",
  "Mohol",
  "MOO",
  "Mortran",
  "Mouse",
  "MPD",
  "CIL",
  "MSL",
  "MUMPS",
  "NASM",
  "NATURAL",
  "Napier88",
  "Neko",
  "Nemerle",
  "nesC",
  "NESL",
  "Net.Data",
  "NetLogo",
  "NetRexx",
  "NewLISP",
  "NEWP",
  "Newspeak",
  "NewtonScript",
  "NGL",
  "Nial",
  "Nice",
  "Nickle",
  "Nim",
  "NPL",
  "Not eXactly C",
  "Not Quite C",
  "NSIS",
  "Nu",
  "NWScript",
  "NXT-G",
  "o:XML",
  "Oak",
  "Oberon",
  "Obix",
  "OBJ2",
  "Object Lisp",
  "ObjectLOGO",
  "Object REXX",
  "Object Pascal",
  "Objective-C",
  "Objective-J",
  "Obliq",
  "Obol",
  "OCaml",
  "occam",
  "occam-π",
  "Octave",
  "OmniMark",
  "Onyx",
  "OpenCL",
  "OpenEdge ABL",
  "OPL",
  "OpenVera",
  "OPRG",
  "OptimJ",
  "Orc",
  "ORCA/Modula-2",
  "Oriel",
  "Orwell",
  "Oxygene",
  "Oz",
  "P",
  "P4",
  "P#",
  "PARI/GP",
  "Pascal",
  "Pawn",
  "PCASTL",
  "PCF",
  "PEARL",
  "PeopleCode",
  "Perl",
  "PDL",
  "Pharo",
  "PHP",
  "PICT",
  "Pike",
  "PILOT",
  "Pipelines",
  "Pizza",
  "PL-11",
  "PL/0",
  "PL/B",
  "PL/C",
  "PL/I",
  "PL/M",
  "PL/P",
  "PL/SQL",
  "PL360",
  "PLEX",
  "PLEXIL",
  "Plus",
  "POP-11",
  "POP-2",
  "Pony",
  "Portable Game Notation",
  "PostScript",
  "POV-Ray SDL",
  "Powerhouse",
  "PowerBuilder",
  "PowerShell",
  "PPL",
  "Processing",
  "Prograph",
  "PROIV",
  "Prolog",
  "Promela",
  "PROSE modeling language",
  "PROTEL",
  "ProvideX",
  "Pure",
  "Pure Data",
  "PureBasic",
  "PureScript",
  "Python",
  "Q (equational programming language)",
  "Q (programming language from Kx Systems)",
  "Qalb",
  "QPL",
  "QtScript",
  "QuakeC",
  "QPL",
  "R",
  "R++",
  "Racket",
  "RAPID",
  "Raven",
  "RDL",
  "REBOL",
  "Red",
  "Redcode",
  "REFAL",
  "Reia",
  "Revolution",
  "REXX",
  "Ring",
  "Rlab",
  "ROOP",
  "RPG",
  "RPL",
  "RSL",
  "RTL/2",
  "Ruby",
  "RuneScript",
  "Rust",
  "S",
  "S-Lang",
  "S-PLUS",
  "S/SL",
  "S2",
  "SabreTalk",
  "SAIL",
  "SALSA",
  "SAM76",
  "SAS",
  "SASL",
  "Sather",
  "Sawzall",
  "Scala",
  "Scheme",
  "Scilab",
  "Scratch",
  "Script.NET",
  "Sed",
  "Seed7",
  "Self",
  "SenseTalk",
  "SequenceL",
  "SETL",
  "SIMPOL",
  "SIGNAL",
  "SiMPLE",
  "SIMSCRIPT",
  "Simula",
  "Simulink",
  "SISAL",
  "SLIP",
  "SMALL",
  "Smalltalk",
  "SML",
  "Snap!",
  "SNOBOL",
  "SPARK",
  "Speedcode",
  "SPIN",
  "SP/k",
  "SPSS",
  "SQR",
  "Squeak",
  "Squirrel",
  "SR",
  "S/SL",
  "Starlogo",
  "Strand",
  "Stateflow",
  "Subtext",
  "SuperCollider",
  "SuperTalk",
  "Swift",
  "SYMPL",
  "SystemVerilog",
  "T",
  "TACL",
  "TADS",
  "TAL",
  "Tcl",
  "Tea",
  "TECO",
  "TELCOMP",
  "TeX",
  "TEX",
  "TIE",
  "Toccata",
  "TOM",
  "TOM-Script",
  "Tool Command Language",
  "Turing",
  "TUTOR",
  "TXL",
  "TypeScript",
  "U-SQL",
  "Ubercode",
  "UCSD Pascal",
  "Umple",
  "Unicon",
  "Uniface",
  "UNITY",
  "Unix shell",
  "UnrealScript",
  "V",
  "Vala",
  "VBA",
  "VBScript",
  "Verilog",
  "VHDL",
  "Visual Basic",
  "Visual Basic .NET",
  "Visual DataFlex",
  "Visual DialogScript",
  "Visual FoxPro",
  "Visual J++",
  "Visual J#",
  "Visual Objects",
  "VSXu",
  "WATFIV",
  "WebDNA",
  "WebQL",
  "Whiley",
  "Winbatch",
  "Wolfram",
  "Wyvern",
  "X++",
  "X10",
  "XBase++",
  "XBase",
  "XC",
  "xHarbour",
  "XL",
  "Xojo",
  "XOTcl",
  "XPath",
  "XPL",
  "XPL0",
  "XQuery",
  "XSB",
  "XSLT",
  "Xtend",
  "Yorick",
  "Yoix",
  "YQL",
  "YUI",
  "Z notation",
  "ZPL",
  "Zig",
  "ZOPL",
  "ZPL",
] as const;

export const IN_LANGUAGE_OPTIONS = [
  "ar-SA",
  "bn-BD",
  "bn-IN",
  "cs-CZ",
  "da-DK",
  "de-AT",
  "de-CH",
  "de-DE",
  "el-GR",
  "en-AU",
  "en-CA",
  "en-GB",
  "en-IE",
  "en-IN",
  "en-NZ",
  "en-US",
  "en-ZA",
  "es-AR",
  "es-CL",
  "es-CO",
  "es-ES",
  "es-MX",
  "es-US",
  "fi-FI",
  "fr-BE",
  "fr-CA",
  "fr-CH",
  "fr-FR",
  "he-IL",
  "hi-IN",
  "hu-HU",
  "id-ID",
  "it-CH",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "nl-BE",
  "nl-NL",
  "no-NO",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "sk-SK",
  "sv-SE",
  "ta-IN",
  "ta-LK",
  "th-TH",
  "tr-TR",
  "zh-CN",
  "zh-HK",
  "zh-TW",
] as const;

export const SOFTWARE_TYPE_OPTIONS = [
  "Command-line tool",
  "Database portal",
  "Desktop application",
  "GUI-framework",
  "Library",
  "Plug-in",
  "Script",
  "Web API",
  "Web application",
  "Web service",
  "Workbench",
  "Workflow",
] as const;

export const DEVELOPMENT_STATUS_OPTIONS = [
  "Abandoned",
  "Active",
  "Concept",
  "Inactive",
  "Moved",
  "Suspended",
  "Unsupported",
  "WIP",
] as const;

export const CYCLE_OF_UPDATES_OPTIONS = [
  "Irregularly",
  "Monthly",
  "Quarterly",
  "Weekly",
] as const;

export const ROLE_NAME_OPTIONS = [
  "Architecture",
  "Coding",
  "Debugging",
  "Design",
  "Documentation",
  "Maintenance",
  "Management",
  "Support",
  "Testing",
] as const;

export const DEVELOPER_STRUCTURE_OPTIONS = [
  "Community (Closed Source Research Software)",
  "Community (Open Source Research Software)",
  "Community (Research Software as a Service)",
  "Contractor (Closed Source Research Software)",
  "Contractor (Open Source Resarch Software)",
  "Contractor (Research Software as a Service)",
  "Individual Researcher",
  "Local Research Group",
  "Project Group",
] as const;

export const DOMAIN_OPTIONS = [
  "Chemistry",
  "Computer Science",
  "Construction Engineering and Architecture",
  "Economics",
  "Electrical Engineering and Information Technology",
  "Fluid Mechanics, Technical Thermodynamics and Thermal Energy Engineering",
  "Geosciences",
  "Jurisprudence",
  "Materials Engineering",
  "Materials Science",
  "Mathematics",
  "Mechanics and Constructive Mechanical Engineering",
  "Physics",
  "Process Engineering, Technical Chemistry",
  "Production Technology",
  "Social Science",
  "Systems Engineering",
] as const;

export const CATEGORY_OPTIONS = [
  "Control strategies for energy systems",
  "Energy markets",
  "Grid planning",
  "Other",
  "Research on components",
  "Transition of the energy system",
] as const;

export const ROLE_IN_RESEARCH_OPTIONS = [
  "Agent-based Modeling",
  "Collaboration Software",
  "Control and Monitoring Software (Embedded, Web-based, Native)",
  "Data Analytics",
  "Data Assimilation",
  "Data Collection",
  "Data Management",
  "Decision Analysis",
  "Integrative Analysis",
  "Laboratory Notebooks",
  "Libraries",
  "Machine Learning",
  "Modeling and Simulation",
  "Numerical Modeling",
  "Observation Data Analytics",
  "Pipelines/Workflows",
  "Proof-of-Concept Software",
  "Research Infrastructure Software",
  "Scientific Visualization",
  "Simulation Data Analytics",
  "Software Management",
  "Statistical Analysis",
] as const;

export const TYPICAL_HARDWARE_OPTIONS = [
  "Desktop Computer/Work station",
  "HPC",
  "Laptop",
] as const;

export const REALTIME_CAPABILITY_OPTIONS = [
  "Firm",
  "Hard",
  "None",
  "Soft",
] as const;

export const OPERATING_SYSTEM_OPTIONS = [
  "Android",
  "Linux",
  "MacOS",
  "Microsoft Windows",
  "iOS",
] as const;

export const ENCODING_FORMAT_OPTIONS = [
  "binary",
  "csv",
  "DataFrame/Serie",
  "db",
  "JSON",
  "mat",
  "mdf5",
  "Pandas",
  "txt",
  "xml",
  "xlsx",
  "YAML",
  "other",
] as const;

export const TEMPORAL_RESOLUTION_OPTIONS = [
  "annual",
  "daily",
  "hourly",
  "minutely",
  "monthly",
  "none",
  "other",
  "quarter-hourly",
  "secondly",
  "unlimited",
  "weekly",
] as const;

export const ENERGY_COMPONENT_TYPE_OPTIONS = [
  "carbon capture and storage technology",
  "chemical energy storage technology",
  "coal power technology",
  "electric mobility technology",
  "electrical energy storage technology",
  "energy storage technology",
  "energy technology",
  "fuel power technology",
  "geothermal heat technology",
  "geothermal power technology",
  "heat generation technology",
  "hydro power technology",
  "kinetic energy storage technology",
  "manufacturing technology",
  "marine hydro power technology",
  "mobility technology",
  "non-energy use technology",
  "nuclear power technology",
  "offshore wind power technology",
  "onshore wind power technology",
  "photovoltaic technology",
  "potential energy storage technology",
  "power generation technology",
  "power-to-fuel technology",
  "power-to-gas technology",
  "power-to-liquid technology",
  "pumped hydro storage power technology",
  "reservoir hydro storage power technology",
  "run of river power technology",
  "sector coupling technology",
  "solar power technology",
  "solar thermal heat technology",
  "solar thermal power technology",
  "thermal energy storage technology",
  "wind power technology",
] as const;

export const LEVEL_OF_DETAIL_OPTIONS = [
  "high (nonlinear equations with a high number of parameters)",
  "low (simple timeseries)",
  "middle (linear equations with some parameters)",
] as const;

export const TEMPORAL_COVERAGE_OPTIONS = [
  "Long term (>=15)",
  "Medium term (>5-<15)",
  "Short term (<= 5 years)",
  "Other",
] as const;

export const STATIONARY_VS_TRANSIENT_OPTIONS = [
  "Stationary",
  "Transient",
] as const;

export const DIMENSIONS_OPTIONS = ["1D", "2D", "3D"] as const;

export const SUPPORTED_VOLTAGE_LEVEL_OPTIONS = [
  "High Voltage",
  "Low Voltage",
  "Medium Voltage",
  "None",
] as const;

// ISO 3166-1 alpha-2 country codes
export const COUNTRY_OF_ORIGIN_OPTIONS = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
] as const;

export const EXAMPLE_TYPE_OPTIONS = [
  "Long",
  "Minimal",
  "Paper",
  "Test",
] as const;

export const VALIDATION_TYPE_OPTIONS = [
  "Analytical verification",
  "Empirical validation",
  "Inter-model comparison",
] as const;

export const COMMUNITY_INTERACTION_TYPE_OPTIONS = [
  "Forum",
  "Github discussions",
  "In-person meet-ups",
  "Issues",
  "Mailinglist",
  "Online meetings",
] as const;

export const COVERS_SECTOR_OPTIONS = [
  "agriculture, forestry and land use sector",
  "building sector",
  "commercial sector",
  "electricity sector",
  "energy demand sector",
  "energy transformation sector",
  "heating and cooling sector",
  "household sector",
  "industry sector",
  "mineral oil refining sector",
  "transport sector",
  "waste and wastewater sector",
] as const;
